<div *ngFor="let _ of repeat" class="shimmer">
  <div class="wrapper">
    <!-- <div class="image-card animate"></div> -->
    <div class="stroke animate title"></div>
    <div class="stroke animate link"></div>
    <div class="stroke animate description"></div>
  </div>
</div>
